@if (data$ | async; as component) {
  <div class="help-container" [style]="'background-color :'+ component.backgroundColor">
    <div class="container" >
      @if (items$ | async; as components) {
        <div class="help-items-list">
          @for (component of components; track component) {
            @if (component) {
              @if (component.typeCode === cmsItemType) {
                <div class="item {{component?.uid}}">
                  <div class="item-content-wrapper" [style]="'background-color :'+ component.background">
                    <a [routerLink]="component?.urlLink?.url">
                      <div class="content-media">
                        <cx-media [container]="component.image"></cx-media>
                      </div>
                      <div class="content-item">
                        <span class="title">{{component.title}}</span>
                        <div class="description">{{component.description}}</div>
                      </div>
                      <div class="content-action">
                        <app-custom-icons [type]="iconTypes.ADD"></app-custom-icons>
                      </div>
                    </a>
                  </div>
                </div>
              }
            }
          }
        </div>
      }
    </div>
  </div>
}
